import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import CircularProgress from '@mui/material/CircularProgress';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'min(432px, 90%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '20px',
  boxSizing: 'border-box',
};

type Props = {
  header: string;
  message: string;
  open: boolean;
};

function LoadingModal({ header, message, open }: Props) {
  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <Box sx={style} className="modal-box">
        <Typography
          id="modal-modal-title"
          variant="h2"
          align="center"
          className="modal-header">
          {header}
        </Typography>
        <Typography
          id="modal-modal-description"
          variant="body1"
          align="center"
          className="modal-body">
          {message}
        </Typography>
        <CircularProgress />
      </Box>
    </Modal>
  );
}

export default LoadingModal;
